import { createFileRoute } from "@tanstack/react-router";
import { AskPanel } from "@/components/ask/AskPanel";

export const Route = createFileRoute("/_authenticated/ask/$threadId")({
  head: () => ({ meta: [
    { title: "Saved conversation · Oxley Assistant" },
    { name: "description", content: "Continue your saved Oxley Assistant conversation." },
    { property: "og:title", content: "Saved conversation · Oxley Assistant" },
    { property: "og:description", content: "Continue your saved Oxley Assistant conversation." },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary" },
  ] }),
  component: ThreadPage,
});
function ThreadPage() {
  const { threadId } = Route.useParams();
  return <AskPanel key={threadId} routeThreadId={threadId} fullPage />;
}